module.exports = __webpack_public_path__ + "static/media/24hundred_back.602b3982.png";